import React from "react";
import PropTypes from "prop-types";
import StatsDetail from "./StatsDetail";
import { Card, CardTitle, CardBody } from "reactstrap";
import ShimmerLoading from "components/Common/Shimmer";

const StatsCard = ({ id, icon, title, value, change, subtitle, isLoading = false }) => {
  return (
    <Card className="card-stats" data-testid={`stats-card-${id}`}>
      <CardTitle className="d-flex align-items-center gap-2">
        {isLoading ? (
          <>
            <ShimmerLoading width={24} height={24} borderRadius="50%" />
            <ShimmerLoading width={120} height={24} />
          </>
        ) : (
          <>
            {icon && <img src={icon} alt={title} data-testid={`stats-icon-${id}`} />}
            <h4 className="font-size-lg" data-testid={`stats-title-${id}`}>
              {title}
            </h4>
          </>
        )}
      </CardTitle>
      <CardBody>
        {isLoading ? (
          <StatsDetail isLoading={true} testId={`${id}-detail-loading`} />
        ) : (
          <div className="d-flex flex-row flex-xl-column">
            {value.map((item, index) => (
              <div key={`${id}-detail-${index}`} className="flex-1">
                <StatsDetail value={item} change={change[index]} testId={`${id}-detail-${index}`} title={subtitle?.[index]} />
                {index + 1 < value.length && <hr className="my-8 d-none d-xl-block" />}
              </div>
            ))}
          </div>
        )}
      </CardBody>
    </Card>
  );
};

StatsCard.propTypes = {
  id: PropTypes.string,
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
  value: PropTypes.number,
  change: PropTypes.number,
  details: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
      change: PropTypes.number,
    })
  ),
  isLoading: PropTypes.bool,
};

export default StatsCard;
